var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"image"}),_c('span',[_vm._v("404")]),_c('span',[_vm._v("Sorry, the page you visited does not exist.")]),_c('ButtonComponent',{attrs:{"onClick":_vm.handleBackHome,"label":"Back Home"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }